import { defineStore } from 'pinia';
import moment from 'moment';

export const useGlobalStateStore = defineStore('globalState', {
    state: () => ({
        showSnackBar: {
            show: false,
            message: '',
            color: '',
        },
        loaderState: false,
        tabs: {
            generalTabs: 0,
            companyTabs: 0,
            employeeTabs: 0,
            logsTabs: 0,
            faqTabs: 0,
        },
        adminSearchRoutes: [
            { text: 'Dashboard',       value: 'dashboard',         action: '',       subject: '' },
            { text: 'Gallery',         value: 'gallery',           action: '',       subject: '' },
            { text: 'Charges',         value: 'charges',           action: '',       subject: '' },
            { text: 'Settings',        value: 'general',           action: '',       subject: '' },
            { text: 'Plans',           value: 'addPlans',          action: 'create', subject: 'plan' },
            { text: 'Coupons',         value: 'coupon',            action: 'create', subject: 'coupon' },
            { text: 'Companies',       value: 'companyList',       action: 'view',   subject: 'company' },
            { text: 'Add Company',     value: 'addCompany',        action: 'create', subject: 'company' },
            { text: 'Employee',        value: 'employee',          action: 'view',   subject: 'HRM' },
            { text: 'Add Employee',    value: 'addEmployee',       action: 'create', subject: 'HRM' },
            { text: 'Lookup Table',    value: 'lookupTable',       action: 'view',   subject: 'lookup' },
            { text: 'Brands',          value: 'brand',             action: 'view',   subject: 'lookup' },
            { text: 'Category',        value: 'category',          action: 'view',   subject: 'lookup' },
            { text: 'City',            value: 'city',              action: 'view',   subject: 'lookup' },
            { text: 'State',           value: 'state',             action: 'view',   subject: 'lookup' },
            { text: 'Country',         value: 'country',           action: 'view',   subject: 'lookup' },
            { text: 'Currency',        value: 'currency',          action: 'view',   subject: 'lookup' },
            { text: 'Customer Group',  value: 'customerGroup',     action: 'view',   subject: 'lookup' },
            { text: 'Tax',             value: 'tax',               action: 'view',   subject: 'lookup' },
            { text: 'Unit',            value: 'unit',              action: 'view',   subject: 'lookup' },
            { text: 'Warehouse',       value: 'warehouse',         action: 'view',   subject: 'lookup' },
            { text: 'Department',      value: 'department',        action: 'view',   subject: 'lookup' },
            { text: 'Manage Roles',    value: 'manageRoles',       action: 'view',   subject: 'role' },
            { text: 'Mail Utilities',  value: 'mailUtility',       action: 'view',   subject: 'mailUtility' },
            { text: 'Logs',            value: 'logApp',            action: 'view',   subject: 'logs' },
            { text: 'Support Tickets', value: 'supportTickets',    action: 'view',   subject: 'ticket' },
            { text: 'Subscriptions',   value: 'subscriptionsList', action: 'create', subject: 'plan' },
            { text: 'CSP Reports',     value: 'cspReports',        action: 'view',   subject: 'cspReport' },
            { text: 'Add Custom Page', value: 'addCustomPage',     action: 'create', subject: 'customPages' },
            { text: 'Custom Pages',    value: 'customPages',       action: 'create', subject: 'customPages' },
            { text: 'Faq',             value: 'faqAdmin',          action: 'create', subject: 'FAQ' },
        ],
    }),

    getters: {
        format_date: () => (date) => moment(date).format('MM/DD/YYYY'),
    },

    actions: {
        SHOW_LOADER(status) {
            this.loaderState = status;
        },
        SHOW_SNACKBAR({ message, color, show }) {
            this.showSnackBar.message = message;
            this.showSnackBar.color = color;
            this.showSnackBar.show = show !== undefined ? show : true;
        },
        HIDE_SNACKBAR() {
            this.showSnackBar.show = false;
        },
        UPDATE_TABS(tab) {
            switch (tab.type) {
                case 0: this.tabs.generalTabs  = tab.value; break;
                case 1: this.tabs.companyTabs  = tab.value; break;
                case 2: this.tabs.employeeTabs = tab.value; break;
                case 3: this.tabs.logsTabs     = tab.value; break;
                case 4: this.tabs.faqTabs      = tab.value; break;
            }
        },
        actionloaderState(status) {
            this.loaderState = status;
        },
        successSnackBar(message) {
            this.SHOW_SNACKBAR({ show: true, color: 'primary', message });
        },
        errorSnackBar(message) {
            this.SHOW_SNACKBAR({ show: true, color: 'red', message });
        },
        snackBarState(snackProp) {
            this.SHOW_SNACKBAR(snackProp);
        },
    },
});
